import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SpaceMonkeyLogo from '../../components/brand/SpaceMonkeyLogo';
import Logo from '../../components/brand/Logo';
import Icon from '../../components/brand/Icon';
import './SpaceMonkeyDashboardPage.css';

const PERMIT_PRICE = 5;

// TODO: Replace sample data with live data from the backend
// (e.g. GET /accounts/spacemonkey/dashboard).
const SUMMARY = {
  permitsSoldToday: 23,
  activePermits: 18,
  validationsToday: 41,
};
const revenueToday = SUMMARY.permitsSoldToday * PERMIT_PRICE;

const RECENT_ACTIVITY = [
  { id: 1, time: '11:42 AM', plate: 'ABC1234', type: 'Permit', detail: 'SM-44821', amount: '$5.00' },
  { id: 2, time: '11:30 AM', plate: 'TXR8890', type: 'Validation', detail: 'SM-12345', amount: 'Free' },
  { id: 3, time: '11:18 AM', plate: 'GHK2201', type: 'Permit', detail: 'SM-44820', amount: '$5.00' },
  { id: 4, time: '10:58 AM', plate: 'LMN5567', type: 'Validation', detail: 'SM-99001', amount: 'Free' },
  { id: 5, time: '10:41 AM', plate: 'PQR3344', type: 'Permit', detail: 'SM-44819', amount: '$5.00' },
];

const QUICK_ACTIONS = [
  { icon: 'car', title: 'View customer parking page', desc: 'See what customers see', to: '/spacemonkey' },
  { icon: 'qr', title: 'Print QR sign', desc: 'Printable lot signage', to: '/spacemonkey/qr-sign' },
  { icon: 'search', title: 'Enforcement lookup', desc: 'Check a license plate', to: '/enforcement' },
  { icon: 'camera', title: 'Scan plate', desc: 'Read a plate with the camera', to: '/enforcement/scan' },
  { icon: 'settings', title: 'Account settings', desc: 'Manage your lot and account', to: '/spacemonkey/settings' },
];

const SpaceMonkeyDashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('authToken')) {
      navigate('/admin/signin');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('accountType');
    navigate('/admin/signin');
  };

  return (
    <div className="smd-page">
      <header className="smd-header">
        <div className="smd-header-inner">
          <SpaceMonkeyLogo light size="md" />
          <div className="smd-header-right">
            <span className="smd-powered"><span>Powered by</span> <Logo size="sm" mono /></span>
            <Link to="/enforcement" className="smd-header-link">Plate Lookup</Link>
            <Link to="/spacemonkey/settings" className="smd-header-link">Settings</Link>
            <button className="smd-logout-btn" onClick={handleLogout}>Log out</button>
          </div>
        </div>
      </header>

      <div className="smd-content">
        <div className="smd-title-row">
          <div>
            <h1>Owner Dashboard</h1>
            <p>Space Monkey Parking · Edinburg, TX</p>
          </div>
          <Link to="/spacemonkey/qr-sign" className="btn btn-primary">Print QR Signs</Link>
        </div>

        {/* Stats */}
        <div className="smd-stats">
          <div className="smd-stat">
            <div className="smd-stat-icon green"><Icon name="dollar" size={22} /></div>
            <div className="smd-stat-label">Today's Revenue</div>
            <div className="smd-stat-value">${revenueToday}</div>
            <div className="smd-stat-sub">{SUMMARY.permitsSoldToday} permits at $5 parking fee</div>
          </div>
          <div className="smd-stat">
            <div className="smd-stat-icon blue"><Icon name="ticket" size={22} /></div>
            <div className="smd-stat-label">Permits Sold Today</div>
            <div className="smd-stat-value">{SUMMARY.permitsSoldToday}</div>
            <div className="smd-stat-sub">Flat $5 fee each</div>
          </div>
          <div className="smd-stat">
            <div className="smd-stat-icon teal"><Icon name="bolt" size={22} /></div>
            <div className="smd-stat-label">Active Permits</div>
            <div className="smd-stat-value">{SUMMARY.activePermits}</div>
            <div className="smd-stat-sub">Valid right now</div>
          </div>
          <div className="smd-stat">
            <div className="smd-stat-icon gray"><Icon name="check" size={22} /></div>
            <div className="smd-stat-label">Customer Validations</div>
            <div className="smd-stat-value">{SUMMARY.validationsToday}</div>
            <div className="smd-stat-sub">Free for customers</div>
          </div>
        </div>

        <div className="smd-grid">
          {/* Recent activity */}
          <div className="smd-card">
            <div className="smd-card-head">
              <h2>Recent Parking Activity</h2>
              <Link to="/enforcement" className="smd-card-link">Enforcement</Link>
            </div>
            {/* Desktop table */}
            <div className="smd-table-wrap">
              <table className="smd-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Plate</th>
                    <th>Type</th>
                    <th>Reference</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {RECENT_ACTIVITY.map(r => (
                    <tr key={r.id}>
                      <td>{r.time}</td>
                      <td className="smd-plate">{r.plate}</td>
                      <td>
                        <span className={`smd-type smd-type-${r.type === 'Permit' ? 'permit' : 'valid'}`}>
                          {r.type}
                        </span>
                      </td>
                      <td>{r.detail}</td>
                      <td>{r.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Mobile cards */}
            <div className="smd-activity-cards">
              {RECENT_ACTIVITY.map(r => (
                <div className="smd-activity-card" key={r.id}>
                  <div className="smd-activity-left">
                    <span className="smd-activity-plate">{r.plate}</span>
                    <span className="smd-activity-meta">{r.time} · {r.detail}</span>
                  </div>
                  <div className="smd-activity-right">
                    <span className="smd-activity-amount">{r.amount}</span>
                    <span className={`smd-type smd-type-${r.type === 'Permit' ? 'permit' : 'valid'}`}>{r.type}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Projection + quick actions */}
          <div className="smd-side">
            <div className="smd-card smd-projection">
              <h2>Your Revenue Projection</h2>
              <p className="smd-projection-sub">Your parking revenue at $5 per permit. Customer also pays a $1 service fee and card processing, which go to RGV Smart Pay.</p>
              {[
                { label: 'Conservative', daily: 15 },
                { label: 'Moderate', daily: 30 },
                { label: 'Peak Lot', daily: 60 },
              ].map(r => (
                <div className="smd-proj-row" key={r.label}>
                  <span className="smd-proj-label">{r.label}</span>
                  <span className="smd-proj-day">${r.daily * PERMIT_PRICE}/day</span>
                  <span className="smd-proj-mo">${(r.daily * PERMIT_PRICE * 30).toLocaleString()}/mo</span>
                </div>
              ))}
            </div>

            <div className="smd-card">
              <h2>Quick Actions</h2>
              <div className="smd-actions">
                {QUICK_ACTIONS.map(a => (
                  <Link to={a.to} className="smd-action" key={a.title}>
                    <span className="smd-action-icon"><Icon name={a.icon} size={20} /></span>
                    <span className="smd-action-text">
                      <span className="smd-action-title">{a.title}</span>
                      <span className="smd-action-desc">{a.desc}</span>
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpaceMonkeyDashboardPage;
